import {map} from 'nanostores'
import { debounce } from '../utils/tickers'

export const $screen = map({
    width: window.innerWidth,
    height: window.innerHeight
})

export const $screenDebounce = map({
    width: window.innerWidth,
    height: window.innerHeight
})

window.addEventListener('resize', () => {
    $screen.setKey('width', window.innerWidth)
    $screen.setKey('height', window.innerHeight)
});

window.addEventListener('resize', debounce(() => {
    $screenDebounce.setKey('width', window.innerWidth)
    $screenDebounce.setKey('height', window.innerHeight)
}, 200));

